import { Injectable } from '@angular/core';

import { ThemesQuery } from './themes.query';
import { ThemesStore } from './themes.store';

@Injectable({ providedIn: 'root' })
export class ThemesService {
  constructor(public query: ThemesQuery, public store: ThemesStore) { }
}
